import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../core/settings/settings.service'; 

@Component({
    selector: '[app-footer]',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    username: any;
    merchantKeyId: any;
    resellerno: any;
    businessName;
    whitelableurl: any;
    whitelabelresellername: any;
    resellername: boolean = false;
    paygname: boolean = true;
    resellerurl: any;
    constructor(public settings: SettingsService) {
         
    }

    ngOnInit() {
        this.whitelableurl = localStorage.getItem("Whitelabelurl");
        this.whitelabelresellername = localStorage.getItem("ResellerName");
        this.resellerurl = localStorage.getItem("ResellerUrl");
        if (this.resellerurl == this.whitelableurl) {
            this.resellername = true;
            this.paygname = false;
        }
        else {
            this.resellername = false;
            this.paygname = true;
        }
    }    
}
